import { BaseContent } from '@fourthwall/components';
import React from 'react';
import * as S from './BlogLink.styled';
export const BlogLink = ({ title, description, thumbnail, href }) => (React.createElement(S.Container, { href: href, target: "_blank", rel: "noreferrer" },
    React.createElement(S.Thumbnail, null,
        React.createElement(S.ThumbnailImage, { src: thumbnail, alt: `${title} thumbnail` })),
    React.createElement("div", null,
        React.createElement("div", null,
            React.createElement(BaseContent, { size: "small" },
                React.createElement("strong", null, title))),
        React.createElement(S.Description, null,
            React.createElement(BaseContent, { size: "small", appearance: "secondary" }, description)))));
